import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Form from 'react-bootstrap/lib/Form';
import { toastr } from 'react-redux-toastr';
import map from 'lodash.map';
import orderBy from 'lodash.orderby';
import isEmpty from 'lodash.isempty';
import axios from 'axios';
import { Formik } from 'formik';
import {
	ThematicAreaDropdownOption,
	DefaultOffice,
	DistrictDropdownOption,
	InitiativeType
} from '../../../utils/enums';
import { Select } from '../../Select';
import { ConsultationInitiativeValidationSchema } from '../../../validators/initiative';
import { ContactListItemConsultationProposalInitiative } from './ContactListItemConsultationProposalInitiative';

class ContactListItemInitiativeContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			verified: true,
			zoom: props.mapConfiguration.zoom,
			locationLatitude: props.mapConfiguration.latitude,
			locationLongitude: props.mapConfiguration.longitude
		};
		this.getComponent = (type) => ContactListItemConsultationProposalInitiative;
		this.initiative = null;
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.mapConfiguration.isCreateConsultationInitiative !==
			this.props.mapConfiguration.isCreateConsultationInitiative
		) {
			this.setState({
				zoom: this.props.mapConfiguration.zoom
			});
		}
	}

	async uploadFile(file) {
		let formData = new FormData();
		formData.append('attachment', file);
		try {
			let response = await axios.post('/api/attachments/initiative-attachement', formData);
			return response.data;
		} catch (e) {
			toastr.error('Błąd podczas uploadu pliku', 'Wystąpił niespodziewany błąd podczas uploadu pliku');
			return -1;
		}
	}
	render() {
		let {
			type,
			title,
			content,
			replyTo,
			attachments,
			thematicAreaId,
			officeId,
			districtId,
			projectId,
			isAuth,
			attachmentConfiguration,
			mapConfiguration,
			reCaptchaConfig,
			mode,
			onSubmit,
			onCancel,
			isCreateConsultationInitiative,
			agreementAccepted,
			agreementHistory,
			agreementAcceptedRequired,
			scrollToAgreement,
			disabled = false
		} = this.props;

		return (
			<div className="container">
				<div className="margin-bottom-20">
					<Formik
						enableReinitialize={true}
						validationSchema={ConsultationInitiativeValidationSchema}
						initialValues={{
							type,
							title,
							content,
							replyTo,
							attachments,
							thematicAreaId,
							officeId,
							districtId,
							projectId,
							isAuth,
							attachmentConfiguration,
							locationLatitude: mapConfiguration.latitude,
							locationLongitude: mapConfiguration.longitude
						}}
						render={({ values, handleChange, handleBlur, isValid, errors, setFieldValue, handleReset }) => {
							const initiativeProps = {
								...values,
								mode: mode,
								errors: errors,
								onChange: handleChange,
								onBlur: handleBlur,
								isValid: isValid,
								setFieldValue: setFieldValue,
								map: this.map,
								isAuth: isAuth,
								isInitiativeCreating: isCreateConsultationInitiative,
								zoomEnd: this.zoomEnd,
								dragEnd: this.dragEnd,
								changeGeoPoint: this.changeGeoPoint,
								uploadFile: this.uploadFile,
								onVerify: this.onVerify,
								onExpire: this.onExpire,
								onError: this.onError,
								verified: this.state.verified,
								reCaptchaConfig: reCaptchaConfig,
								stateLocationLatitude: this.state.locationLatitude,
								stateLocationLongitude: this.state.locationLongitude,
								stateZoom: this.state.zoom,
								disabled: disabled
							};
							const InitiativeComponent = this.getComponent(values.type);
							return (
								<Form
									method="post"
									onReset={onCancel}
									onSubmit={(e) => {
										e.preventDefault();
										e.stopPropagation();
										if (!isEmpty(agreementHistory) && !agreementAccepted) {
											scrollToAgreement();
										} else {
											onSubmit(values);
											handleReset();
										}
									}}
									disabled={disabled}
								>
									<InitiativeComponent ref={(ref) => (this.initiative = ref)} {...initiativeProps} />
								</Form>
							);
						}}
					/>
				</div>
			</div>
		);
	}
}

ContactListItemInitiativeContainer.defaultProps = {
	disabled: false,
	type: InitiativeType.BudgetProject,
	title: '',
	content: '',
	replyTo: '',
	attachments: [],
	attachmentConfiguration: {
		maxAttachmentQuantity: 3,
		maxAttachmentSize: 5,
		maxAllAttachmentsSize: 15
	},
	cost: 0,
	thematicAreaId: ThematicAreaDropdownOption.NotSetted,
	districtId: DistrictDropdownOption.NotSetted,
	officeId: DefaultOffice.NotSetted,
	thematicAreas: [],
	districts: [],
	isAuth: false,
	reCaptchaConfig: {
		reCaptchaKey: ''
	},
	isInitiativeCreating: false,
	onSubmit: Function.prototype,
	setFieldValue: Function.prototype
};

const mapStateToProps = (state, ownProps) => {
	return {
		isCreateConsultationInitiative: state.initiative.isCreateConsultationInitiative
	};
};

export const ContactListItemInitiative = connect(mapStateToProps)(ContactListItemInitiativeContainer);
